<div
  fxlayout="row wrap"
  class="page-breadcrumb"
  style="flex-flow: row wrap; box-sizing: border-box; display: flex"
>
  <div
    fxflex="50"
    fxflex.sm="100"
    fxflex.xs="100"
    class="align-self-center"
    style="flex: 1 1 50%; box-sizing: border-box; max-width: 50%"
  >
    <h2 class="page-title m-0" *ngIf="itemLinks" [style.color]="'#E7154A'">
      {{ itemLinks.title }}
    </h2>
  </div>

  <div
    fxflex="50"
    fxflex.sm="100"
    fxflex.xs="100"
    class="align-self-center"
    style="flex: 1 1 50%; box-sizing: border-box; max-width: 50%"
  >
    <div class="breadcrumb d-flex align-items-center float-right float-sm-left">
      <ul class="list-style-none d-flex align-items-center">
        <li
          class="breadcrumb-item ng-star-inserted"
          *ngFor="let link of itemLinks.links"
        >
          <a routerLink="{{ link.valor }}">{{ link.indice }}</a>
        </li>
        <li class="breadcrumb-item active ng-star-inserted">
          {{ itemLinks.title }}
        </li>
      </ul>
    </div>
  </div>
</div>
